<h2 mat-dialog-title>
  <mat-icon svgIcon="layers"></mat-icon>
  Administrér afdelingsgrupper
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<mat-dialog-content class="reduced-padding">
  <div class="form-row form-row--multi-select nolimits">
    <div class="multi-select">
      <adm-department-group-list
        [departmentGroups]="departmentGroups()"
        [editMode]="editMode"
        (updateDepartmentGroup)="onUpdateDepartmentGroup($event)"
        (update)="reload()" />
      <adm-department-group-input
        [departmentGroups]="departmentGroups()"
        [departmentGroupToEdit]="departmentGroupToEdit"
        [organizationId]="data.organizationId"
        (done)="doneEditing()" />
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="row-reverse">
  <button mat-button (click)="cancel()">Luk</button>
</mat-dialog-actions>
